import { Box, ModalHeader, TrustPilotAnchor, Typo } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { TKey, useWriskTranslation } from '../../../infrastructure/internationalisation'
import { WriskTrans } from '../trans'

const tKey = TKey('components.feedback-modal-trust-pilot')

export const FeedbackModalTrustPilot: FunctionComponent = () => {
  const { t } = useWriskTranslation()

  return (
    <Box>
      <ModalHeader header={t(tKey('header'))} />
      <Typo>{t(tKey('text'))}</Typo>
      <TrustPilotAnchor mt={4}>{t(tKey('actions.review'))}</TrustPilotAnchor>
      <Typo mt={4}>
        <WriskTrans t={t} i18nKey={tKey('further-questions')} />
      </Typo>
    </Box>
  )
}
